import { makeStyles } from '@material-ui/styles';

import { grey750 } from '../ThemeProvider';

const FOOTER_HEIGHT = 56;
const SIDEBAR_WIDTH = 56;
const CONTROL_HEIGHT = 42;

export const useStyles = makeStyles(({ palette, zIndex }) => ({
    footer: {
        position: 'fixed',
        bottom: '-1px',
        marginLeft: SIDEBAR_WIDTH,
        zIndex: zIndex.drawer + 1,

        display: 'flex',
        width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        minHeight: FOOTER_HEIGHT,
        alignItems: 'center',
        boxSizing: ' border-box',
    },
    activeButton: {
        borderWidth: '2px',
        borderColor: palette.primary3Color,
    },
    cancel: {
        '&.MuiButton-root': {
            color: palette.warningColor,
        },
    },
    badge: {
        top: '-12px',
        left: '-32px',
    },
    button: {
        backgroundColor: palette.type === 'light' ? palette.grey['300'] : grey750,
        color: palette.type === 'light' ? palette.grey['700'] : palette.accent3Color,
        textTransform: 'none',

        '&.MuiButton-root': {
            fontSize: '16px',
        },

        '&:hover': {
            backgroundColor: palette.type === 'light' ? palette.grey['300'] : grey750,
        },
    },
    statusSend: {
        fill: '#4CAF50',
    },
    statusEdit: {
        fill: '#40C4FF',
    },
    swiper: {
        height: CONTROL_HEIGHT,
    },
    wraper: {
        flex: 1,

        '@media (min-width:900px)': {
            margin: '0 20px',
        },
    },
}));
